import { useContext, createContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getAuth } from "firebase/auth";
import { FirebaseApp } from ".";
import SignupFunction from "./firebase/signup";
import LoginFunction from "./firebase/login";
import LogoutFunction from "./firebase/logout";
import GoogleoAuth from "./firebase/oAuthGoogle";

const AuthContext = createContext();

const AuthContextProvider = ({ children }) => {
  
  const auth = getAuth(FirebaseApp);
  auth.useDeviceLanguage();

  const [isAuthenticated, setAuthenticated] = useState(false);
  const [invalidCredentials, setInvalidCredentials] = useState(false);
  const [userExists, setUserExists] = useState(false);
  const [isLogout, setIsLogut] = useState(false);
  const [ifAccExists, setIfAccExists] = useState(false);

  useEffect(() => {
    // Check localStorage for user authentication state on component mount
    const storedAuthenticated = localStorage.getItem("isAuthenticated");
    const storedUserExists = localStorage.getItem("userExists");

    if (storedAuthenticated && storedUserExists) {
      setAuthenticated(true);
      setUserExists(true);
    } else {
      setAuthenticated(false);
      setUserExists(false);
    }
  }, []);
  const redirect = useNavigate();

  //function to trigger signup
  const signup = (email, password, name, image) =>
    SignupFunction(
      auth,
      redirect,
      setIfAccExists,
      email,
      password,
      name,
      image
    );

  const login = (email, password) =>
    LoginFunction(
      auth,
      redirect,
      setIsLogut,
      setIfAccExists,
      setInvalidCredentials,
      setAuthenticated,
      setUserExists,
      email,
      password
    );
  const logout = () =>
    LogoutFunction(auth, redirect, setIfAccExists, setIsLogut, setUserExists);

  const loginByOAuthGoogle = () =>
    GoogleoAuth(auth, redirect, setAuthenticated, setUserExists);

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        userExists,
        ifAccExists,
        isLogout,
        invalidCredentials,
        login,
        logout,
        signup,
        loginByOAuthGoogle,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuthContext = () => useContext(AuthContext);

export default AuthContextProvider;
